import { atom, selector } from 'recoil';
import { ASSET_TYPE_VEHICLE } from '../constants/asset';
import { AssetType } from '../types/asset';

export const fleetAssetsReloadListState = atom<boolean>({
  key: 'app.fleet.assets.reload',
  default: false,
});

export const fleetAssetsFiltersState = atom<{
  page: number;
  brandId?: string;
  subBrandId?: string;
  assetTypes: AssetType[];
  search: string;
}>({
  key: 'app.fleet.assets.filters',
  default: {
    page: 1,
    search: '',
    assetTypes: [ASSET_TYPE_VEHICLE],
    brandId: undefined,
    subBrandId: undefined,
  },
});

export const fleetAssetsHasAnyFilterState = selector<boolean>({
  key: 'app.fleet.assets.filters.any',
  get: ({ get }) => {
    const filters = get(fleetAssetsFiltersState);
    const hasBrandIdFilter = filters.brandId !== undefined;
    const hasSubBrandIdFilter = filters.subBrandId !== undefined;
    const hasAssetTypes = !!filters.assetTypes && filters.assetTypes?.length > 0;

    return hasBrandIdFilter || hasSubBrandIdFilter || hasAssetTypes;
  },
});
